/* import __COLOCATED_TEMPLATE__ from './fly-modal.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { tabbable } from 'tabbable';
/**
    ```hbs
      <FlyModal @title="This is a modal" @onClose={{onClose}} as |closeModal|>
        <div class="fly-panel-body">
          This is the modal body
        </div>

        <div class="fly-panel-footer">
          <button {{on "click" closeModal}} type="button" class="fly-btn">Cancel</button>
          <button {{on "click" this.action}} type="button" class="fly-btn fly-btn--primary">Save</button>
        </div>
      </FlyModal>
    ```

    To ensure proper scroll on the FlyModal, the `fly-panel-body` should be added when creating the modal.
  @public
  @class FlyModal
 **/
let FlyModal = (_class = class FlyModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "triggerElement", _descriptor, this);
    _initializerDefineProperty(this, "modalElement", _descriptor2, this);
    this.triggerElement = document.activeElement;
  }
  handleKeydown(event) {
    if ((event.key === 'esc' || event.key === 'Escape') && !this.args.disableManualClose) {
      this.args.onClose();
    }

    // Part of being an accessible modal means that we have to trap focus in
    // order to keep keyboard navigation within the context of the modal itself
    if (event.key === 'Tab' && this.modalElement != null) {
      let focusableElements = tabbable(this.modalElement);

      // If there are no focusable elements, or there's only one, there's
      // nothing to wrap to and focus should remain where it is.
      if (focusableElements.length <= 1) {
        event.preventDefault();
        return;
      }

      // If the user is holding shift, then they're going backwards in the tab
      // order and we need to wrap to the *last* focusable element. If they're
      // not holding shift, then we need to wrap them to the first focusable
      // element.
      let [firstElement, lastElement] = [focusableElements[0], focusableElements[focusableElements.length - 1]];
      let comparisonElement = event.shiftKey ? firstElement : lastElement;
      let nextElement = event.shiftKey ? lastElement : firstElement;
      if (event.target === comparisonElement) {
        event.preventDefault();
        nextElement.focus();
      }
    }
  }
  onClose(evt) {
    this.triggerElement?.focus();
    this.args.onClose(evt);
  }
  setupFocus(el) {
    this.modalElement = el;
    let focusableElements = tabbable(el);
    // Current TS version doesn't have `autofocus` typed on HTMLElement
    let autofocusElement = focusableElements.find(el => el.autofocus);
    if (autofocusElement == null) {
      focusableElements[0]?.focus();
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "triggerElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "modalElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setupFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupFocus"), _class.prototype)), _class);
export { FlyModal as default };